import { Box, Typography } from '@mui/material';
import RESOURCES from '~/resources';
import CirclePlaneImage from '~/assets/images/jsx/CirclePlaneImage';
import Button from '~/components/Button';
import { BUTTON_TYPES, BUTTON_SIZES } from '~/data/constants';
import { useCallback, useMemo } from 'react';
import { ROUTES } from '~/data/routes';
import { useIsMobile } from '~/hooks/useIsMobile';
import {
  ContactUsSuccessPageTitleDesktop,
  ContactUsSuccessPageTitleMobile,
  ContactUsSuccessPageDescDesktop,
  ContactUsSuccessPageDescMobile,
  leaveDetailsButtonStyle,
  useStyles,
} from './useStyles';
import { useRouter } from 'next/router';

type ContactUsSuccessPageProps = {
  className?: string;
  isToHomePage?: boolean;
  isFullHeight?: boolean;
};

export const ContactUsSuccessPage = ({
  className,
  isToHomePage = false,
  isFullHeight = false,
}: ContactUsSuccessPageProps) => {
  const classes = useStyles;
  const router = useRouter();

  const isMobile = useIsMobile();

  const onClickNavToHome = useCallback(() => {
    router.push(ROUTES.HOMEPAGE);
  }, [router]);

  const styles = useMemo(() => {
    return isMobile
      ? {
          title: ContactUsSuccessPageTitleMobile,
          desc: ContactUsSuccessPageDescMobile,
        }
      : {
          title: ContactUsSuccessPageTitleDesktop,
          desc: ContactUsSuccessPageDescDesktop,
        };
  }, [isMobile]);

  return (
    <Box
      sx={classes.root}
      className={className}
      style={isFullHeight ? { height: '100%' } : undefined}
    >
      <Box sx={classes.container}>
        <Box sx={classes.imageWidget}>
          <CirclePlaneImage />
        </Box>
        <Typography variant="h2" style={styles.title}>
          {RESOURCES.CONTACT_US_SUCCESS_PAGE_TITLE}
        </Typography>
        <Typography variant="subtitle1" style={styles.desc} tabIndex={0}>
          {RESOURCES.CONTACT_US_SUCCESS_PAGE_DESC}
        </Typography>
        {isToHomePage && (
          <Button
            label={RESOURCES.FINISH_LEAVE_DETAILS_BUTTON}
            type={BUTTON_TYPES.MAIN}
            size={BUTTON_SIZES.LARGE}
            onClickFunc={onClickNavToHome}
            customStyle={leaveDetailsButtonStyle}
          />
        )}
      </Box>
    </Box>
  );
};
